<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';
import Address from '../../components/mineTable/address.vue';
import AddressPopup from '../../components/mineTable/addressPopup.vue';

export default {
    name: "mineaddress",
    data() {
        return {
            isLoading: false,
            isShowDetail: false,
            listActiveIndex: null,
        };
    },
    computed: {
        ...mapState(['addressList']),
    },
    components: {
        Loading,
        Address,
        AddressPopup
    },
    mounted() {
        this.getList();
    },
    destroyed() {},
    watch: {
        // 弹窗显示/隐藏监听
        isShowDetail: {
            handler(val) {
                if(val){
                    document.body.style.overflow = 'hidden';
                }else{
                    document.body.style.overflow = 'auto';
                }
            },
            immediate: true
        },
    },
    methods: {
        // 添加新地址
        addNewAddress() { 
            this.isShowDetail = true;
            this.listActiveIndex = null;
        },
        // 修改
        edit(index) { 
            this.isShowDetail = true;
            this.listActiveIndex = index;
        },
        // 获取列表
        getList() { 
            this.isLoading = true;
            this.$store.dispatch('getAddressList').then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    // this.addressList = result.data;
                } else {
                    this.$showToast({ text: result.msg || '地址列表获取失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: err.message || '地址列表获取失败' });
            });
        },
        // 点击删除
        del(id, isMobile = false) { 
            if (isMobile) { 
                this.$showModal({
                    text: '是否确认删除？',
                    onHide: (type) => {
                        if (type === 'confirm') {
                            // this.list.splice(index, 1);
                            this.delAddress(id);
                        }
                    },
                });
            } else {
                if (confirm('是否确认删除？')) { 
                    // this.list.splice(index, 1);
                    this.delAddress(id);
                }
            }
        },
        // 删除地址
        delAddress(id) { 
            this.$showLoading();
            this.$store.dispatch('deleteAddress', {
                id: id,
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '地址删除成功' });
                    this.getList();
                } else {
                    this.$showToast({ text: result.msg || '地址删除失败' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: err.message || '地址删除失败' });
            });
        },
        // 是否置顶
        top(index) { 
            const item = this.addressList[index];
            this.$showLoading();
            this.$store.dispatch('topAddress', {
                id: item.id,
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: item.is_top == 1 ? '取消置顶成功' : '置顶成功' });
                    this.getList();
                } else {
                    this.$showToast({ text: result.msg || (item.is_top == 1 ? '取消置顶失败' : '置顶失败') });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: err.message || (item.is_top == 1 ? '取消置顶失败' : '置顶失败') });
            });
        },
        // 设为默认地址
        setDefault(index) { 
            const item = this.addressList[index];
            this.$showLoading();
            this.$store.dispatch('defaultAddress', {
                id: item.id,
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '设置默认地址成功' });
                    this.getList();
                } else {
                    this.$showToast({ text: result.msg || '设置默认地址失败' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: err.message || '设置默认地址失败' });
            });
        },
        // 地址保存回调
        addressSave(data, isAdd) { 
            this.$showLoading();
            if (isAdd) { 
                // 添加
                this.$store.dispatch('addAddress', {
                    ...data,
                }).then((result) => {
                    this.$hideLoading();
                    if (result.code == 100) {
                        this.$showToast({ text: '地址添加成功' });
                        // this.list.push(data);
                        this.getList();
                    } else {
                        this.$showToast({ text: result.msg || '地址添加失败' });
                    }
                }).catch((err) => {
                    this.$hideLoading();
                    this.$showToast({ text: err.message || '地址添加失败' });
                });
            } else { 
                // 修改
                if (this.listActiveIndex !== null) { 
                    // this.$set(this.list, this.listActiveIndex, data);
                    this.$store.dispatch('editAddress', {
                        ...data,
                    }).then((result) => {
                        this.$hideLoading();
                        if (result.code == 100) {
                            this.$showToast({ text: '地址修改成功' });
                            // this.$set(this.list, this.listActiveIndex, data);
                            this.getList();
                        } else {
                            this.$showToast({ text: result.msg || '地址修改失败' });
                        }
                    }).catch((err) => {
                        this.$hideLoading();
                        this.$showToast({ text: err.message || '地址修改失败' });
                    });
                }
            }
            this.isShowDetail = false;
        },
    },
};
</script>

<template>
    <div class="address">
        <div class="top flex align_end justify_between">
            <p class="title only_pc">我的收货地址</p>
            <p class="title only_mobile"></p>
            <p class="btn_add" @click="addNewAddress">添加新地址</p>
        </div>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <p class="no_more" v-else-if="addressList.length == 0">你还没有收货地址</p>
        <!-- 地址列表 -->
        <Address v-else :data="addressList" @edit="edit" @delete="del" @top="top" @setDefault="setDefault"/>
        <!-- 地址详情弹窗 -->
        <AddressPopup :show="isShowDetail" :data="listActiveIndex !== null ? addressList[listActiveIndex] : {}" @close="isShowDetail = false" @save="addressSave"/>
    </div>
</template>

<style scoped lang="scss">
.address{
    .top{
        margin-bottom: .4rem;
        @media screen and (max-width: 750px) {
            margin-bottom: .1rem;
        }
        .title{
            margin-bottom: 0;
        }
        .btn_add{
            font-size: .16rem;
            cursor: pointer;
            @media screen and (max-width: 750px) {
                font-size: .24rem;
            }
        }
    }
}
</style>